import React from "react";
import { Link } from "react-router-dom";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";

const BlogDetails = ({ post, prevPost, nextPost, lang, settings }) => {
  if (!post) {
    return (
      <div className="container py-5">
        {lang === "tr" ? "404 — Yazı bulunamadı." : "404 — Post not found."}
      </div>
    );
  }

  const t = post.translations?.[lang] || {};
  const cover = fileUrl(API_FILE_URL, post.cover);
  const dateStr = post.date
    ? new Date(post.date).toLocaleDateString(lang, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";
  const publicUrl = process.env.PUBLIC_URL + "/";

  return (
    <div className="ltn__page-details-area ltn__blog-details-area mb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="ltn__blog-details-wrap">
              <div className="ltn__page-details-inner ltn__blog-details-inner">
                <div className="ltn__blog-meta">
                  <ul>
                    <li className="ltn__blog-category">
                      <Link to="/haberler">
                        {lang === "tr" ? "HABER" : "NEWS"}
                      </Link>
                    </li>
                  </ul>
                </div>

                <h2 className="ltn__blog-title">{t.title || post.slug}</h2>

                <div className="ltn__blog-meta">
                  <ul>
                    <li className="ltn__blog-author go-top">
                      <Link to="/haberler">
                        <img
                          src={
                            settings?.favicon
                              ? API_FILE_URL + settings.favicon
                              : publicUrl + "assets/img/blog/author.jpg"
                          }
                          alt="Safkar Icon"
                        />
                        Safkar
                      </Link>
                    </li>
                    <li className="ltn__blog-date">
                      <i className="far fa-calendar-alt" />
                      {dateStr}
                    </li>
                  </ul>
                </div>

                {cover && <img src={cover} alt={t.title || post.slug} />}
                <div dangerouslySetInnerHTML={{ __html: t.content || "" }} />

                {/* Blog Images */}
                {post.images && post.images.length > 0 && (
                  <div className="row mt-30">
                    {post.images.map((img, index) => (
                      <div className="col-lg-6 col-md-6 mb-30" key={index}>
                        <img
                          src={fileUrl(API_FILE_URL, img)}
                          alt={`${t.title || post.slug} - ${index + 1}`}
                          className="img-fluid" // bootstrap class for responsive images
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {Array.isArray(t.tags) && t.tags.length > 0 && (
                <div className="ltn__blog-tags-social-media mt-80 row">
                  <div className="ltn__tagcloud-widget col-lg-8 go-top">
                    <h4>{lang === "tr" ? "Etiketler" : "Tags"}</h4>
                    <ul>
                      {t.tags.map((tg) => (
                        <li key={tg}>
                          <Link to="#">{tg}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              <hr />

              {/* Prev / Next */}
              <div className="ltn__prev-next-btn row mb-50">
                <div className="blog-prev col-lg-6">
                  {prevPost && (
                    <>
                      <h6>{lang === "tr" ? "Önceki Yazı" : "Previous Post"}</h6>
                      <h3 className="ltn__blog-title">
                        <Link
                          to={{
                            pathname: `/haber/${prevPost.slug}`,
                            state: { id: prevPost.id },
                          }}
                        >
                          {prevPost.translations?.[lang]?.title ||
                            prevPost.slug}
                        </Link>
                      </h3>
                    </>
                  )}
                </div>

                <div className="blog-prev blog-next text-right text-end col-lg-6">
                  {nextPost && (
                    <>
                      <h6>{lang === "tr" ? "Sonraki Yazı" : "Next Post"}</h6>
                      <h3 className="ltn__blog-title">
                        <Link
                          to={{
                            pathname: `/haber/${nextPost.slug}`,
                            state: { id: nextPost.id },
                          }}
                        >
                          {nextPost.translations?.[lang]?.title ||
                            nextPost.slug}
                        </Link>
                      </h3>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Sidebar istersen buraya */}
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
